import type { PropsWithChildren } from "react";
import { cx } from "@/utils/cx";

type CreamCardProps = { className?: string } & PropsWithChildren;

export const CreamCard = ({ className, children }: CreamCardProps) => (
  <div className={cx("bg-[#fcf6f1] border border-border-primary rounded-md px-6 pt-6 pb-8 w-full", className)}>
    {children}
  </div>
);
